import { http } from '../../core/services';

const search = (category, type, term, page) =>
  http.get('/api/providers/search', { params: { category, type, term, offset: page } }).then(response => response.data);

export default search;
